import React from "react";
import { Users, Receipt, Tag, Percent, CreditCard } from "lucide-react";
import store from "../store";

const OrderStats = ({ data }) => {
  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(amount)
      .replace("INR", "₹");

  const renderStatCard = ({ icon: Icon, label, value, variant = "blue" }) => (
    <div className={`rounded-xl p-3 space-y-0.5 order-stats__card`}>
      <div className="flex items-center gap-1.5">
        <div className={`p-1 rounded-lg`}>
          <Icon className={`w-4 h-4 text-${variant}-600`} />
        </div>
        <span className="text-xs font-medium text-gray-600">{label}</span>
      </div>
      <div className={`text-xl font-bold text-${variant}-600`}>{value}</div>
    </div>
  );

  const renderTaxBox = ({ label, value }) => (
    <div className="bg-variant-gray rounded-xl p-2 border border-variant-gray order-stats__card">
      <div className="text-xs font-medium text-gray-600">{label}</div>
      <div className="text-lg font-bold text-gray-800">
        {formatCurrency(value)}
      </div>
    </div>
  );

  const statsData = [
    {
      icon: Users,
      label: "Total Orders",
      value: data.totalOrders,
      variant: "blue",
    },
    {
      icon: Receipt,
      label: "Avg Order Value",
      value: formatCurrency(data.avgOrderValue),
      variant: "purple",
    },
    {
      icon: Tag,
      label: "Total Discount",
      value: formatCurrency(data.salesData.discount),
      variant: "emerald",
    },
    {
      icon: CreditCard,
      label: "Pending Payments",
      value: formatCurrency(data.paymentMethods.pending),
      variant: "red",
    },
  ];

  const taxData = [
    { label: "CGST", value: data.taxBreakdown.cgst },
    { label: "SGST", value: data.taxBreakdown.sgst },
  ];

  return (
    <div className="bg-white rounded-xl flex flex-col">
      <div className="flex-1 space-y-3">
        {/* Stats Grid */}
        <div className="grid grid-cols-2 gap-3">
          {statsData.map((stat, index) => renderStatCard(stat))}
        </div>

        {/* Tax Information */}
        {store.GST.active &&
          (data.taxBreakdown.cgst > 0 || data.taxBreakdown.sgst > 0) && (
            <div className="space-y-2 pt-2 mt-2 border-t border-gray-100">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1.5">
                  <div className="p-1 rounded-lg bg-variant-icon-blue">
                    <Percent className="w-4 h-4 text-variant-blue" />
                  </div>
                  <span className="text-xs font-medium text-gray-600">
                    Tax Breakdown
                  </span>
                </div>
                <div className="text-xs font-semibold text-gray-700">
                  Total: {formatCurrency(data.taxBreakdown.totalGst)}
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                {taxData.map((tax, index) => renderTaxBox(tax))}
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default OrderStats;
